import { createFormActionTypes, createRequestActionTypes } from '@td/utils';

export const PROVIDER_SURGE_INCENTIVE_SEARCH_FORM = createFormActionTypes(
  'provider_surge_incentive',
  'PROVIDER_SURGE_INCENTIVE_SEARCH_FORM'
);

export const PROVIDER_SURGE_INCENTIVE_UPDATE_SEARCH_FILTERS =
  'provider_surge_incentive/PROVIDER_SURGE_INCENTIVE_UPDATE_SEARCH_FILTERS';

export const PROVIDER_SURGE_INCENTIVE_SEARCH_REQUEST = createRequestActionTypes(
  'provider_surge_incentive',
  'PROVIDER_SURGE_INCENTIVE_SEARCH_REQUEST'
);

export const PROVIDER_SURGE_INCENTIVE_SET_INCENTIVES =
  'provider_surge_incentive/PROVIDER_SURGE_INCENTIVES_SET_INCENTIVES';

export const PROVIDER_SURGE_INCENTIVE_CREATE_FORM = createFormActionTypes(
  'provider_surge_incentive',
  'PROVIDER_SURGE_INCENTIVE_CREATE_FORM'
);

export const PROVIDER_SURGE_INCENTIVE_CREATE_REQUEST = createRequestActionTypes(
  'provider_surge_incentive',
  'PROVIDER_SURGE_INCENTIVE_CREATE_REQUEST'
);

export const PROVIDER_SURGE_INCENTIVE_EDIT_FORM = createFormActionTypes(
  'provider_surge_incentive',
  'PROVIDER_SURGE_INCENTIVE_EDIT_FORM'
);

export const PROVIDER_ACTIVE_SURGE_INCENTIVE_EDIT =
  'provider_surge_incentive/PROVIDER_ACTIVE_SURGE_INCENTIVE_EDIT';

export const PROVIDER_UPCOMING_SURGE_INCENTIVE_EDIT =
  'provider_surge_incentive/PROVIDER_UPCOMING_SURGE_INCENTIVE_EDIT';

export const PROVIDER_SURGE_INCENTIVE_EDIT =
  'provider_surge_incentive/PROVIDER_SURGE_INCENTIVE_EDIT';

export const PROVIDER_SURGE_INCENTIVE_EDIT_REQUEST = createRequestActionTypes(
  'provider_surge_incentive',
  'PROVIDER_SURGE_INCENTIVE_EDIT_REQUEST'
);

export const PROVIDER_SURGE_INCENTIVE_DELETE_REQUEST = createRequestActionTypes(
  'provider_surge_incentive',
  'PROVIDER_SURGE_INCENTIVE_DELETE_REQUEST'
);

export const SHOW_FLASH_MESSAGE = 'provider_surge_incentive/SHOW_FLASH_MESSAGE';

export const HIDE_FLASH_MESSAGE = 'provider_surge_incentive/HIDE_FLASH_MESSAGE';
